import { TYPES } from "./finance_supporter.type";
import dayjs from "dayjs";

const initState = {
  financeSupporterAll: null,
  financeSupporterOpenAdd: false,
  financeSupporterOpenEdit: false,
  financeSupporterSelected: null,
  financeSupporterSearch: "",
  //
  financeSupporterDates: [dayjs().subtract(1, "months"), dayjs()],
};

const financeSupporterReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_FINANCE_SUPPORTER_ALL:
      return {
        ...state,
        financeSupporterAll: payload,
      };

    case TYPES.SET_FINANCE_SUPPORTER_OPEN_ADD:
      return {
        ...state,
        financeSupporterOpenAdd: payload,
      };

    case TYPES.SET_FINANCE_SUPPORTER_OPEN_EDIT:
      return {
        ...state,
        financeSupporterOpenEdit: payload,
      };

    case TYPES.SET_FINANCE_SUPPORTER_SELECTED:
      return {
        ...state,
        financeSupporterSelected: payload,
      };

    case TYPES.SET_FINANCE_SUPPORTER_SEARCH:
      return {
        ...state,
        financeSupporterSearch: payload,
      };

    case TYPES.SET_FINANCE_SUPPORTER_DATES:
      return {
        ...state,
        financeSupporterDates: payload,
      };

    default:
      return state;
  }
};

export default financeSupporterReducer;
